import { render, staticRenderFns } from "./ProductSpecificationsSelect.vue?vue&type=template&id=2b273ae4"
import script from "./ProductSpecificationsSelect.vue?vue&type=script&lang=js"
export * from "./ProductSpecificationsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports